"use strict";

function wait(duration) {
	return new Promise(function(resolve) {
		setTimeout(resolve, duration);
	});
}

function debounce(callback, delay) {
	let timeout = null;

	return function() {
		clearTimeout(timeout);

		timeout = setTimeout(function() {
			callback();
		}, delay);
	};
}

/**
 *    ######## #### ##       ######## ######## ########   ######  
 *    ##        ##  ##          ##    ##       ##     ## ##    ## 
 *    ##        ##  ##          ##    ##       ##     ## ##       
 *    ######    ##  ##          ##    ######   ########   ######  
 *    ##        ##  ##          ##    ##       ##   ##         ## 
 *    ##        ##  ##          ##    ##       ##    ##  ##    ## 
 *    ##       #### ########    ##    ######## ##     ##  ######  
 */
function filterProducts() {

	const productsContainer = $('.all-products-ctn');
	const products = productsContainer.find('.all-products').get(0);

	if (!productsContainer.length || !products) return;

	const searchTerm = String($('#search-input').val() || '').toLowerCase().trim();
	const activeFilters = getActiveCategoryFilters();

	// Loading animation
	productsContainer.addClass('--loading');
	products.classList.add('--transitioning');

	// Handle products visibility while loading animation at 0.6s
	wait(600).then(function() {
		animateProductsContainerHeight(function() {
			handleProductsVisibility(searchTerm, activeFilters);
		});
	});

	// Remove loading state after 1.2s
	wait(1200).then(function() {
		products.classList.remove('--transitioning');
		productsContainer.removeClass('--loading');
	});
}

function getActiveCategoryFilters() {
	const activeFilters = [];

	$('.module-categories-filters .checkbox-group input:checked').each(function() {
		const category = this.dataset.category;
		const subcategory = this.dataset.subcategory;

		if (!category || category === 'all') return;

		activeFilters.push({
			category: category,
			subcategory: subcategory
		});
	});

	return activeFilters;
}

function handleProductsVisibility(searchTerm, activeFilters) {
	let visibleProductsCount = 0;

	$('.products-grid .product-card').each(function() {
		const product = this;

		const title = $(product).find('.title').text().toLowerCase();

		const productCategory = product.dataset.category;
		const productSubcategory = product.dataset.subcategory;

		const searchMatch =
			searchTerm === '' ||
			title.includes(searchTerm);

		let categoryMatch = true;

		if (activeFilters.length > 0) {
			categoryMatch = activeFilters.some(function(filter) {
				const categoryMatches = productCategory === filter.category;

				const subcategoryMatches =
					!filter.subcategory ||
					filter.subcategory === 'all' ||
					productSubcategory === filter.subcategory;

				return categoryMatches && subcategoryMatches;
			});
		}

		const isVisible = searchMatch && categoryMatch;

		if (isVisible) {
			product.classList.remove('--hidden', 'invisible');
			visibleProductsCount++;
		} else {
			product.classList.add('--hidden');
		}
	});

	updateCategoriesVisibility();

	if (visibleProductsCount === 0) {
		$('.no-products').addClass('--is-visible');
	} else {
		$('.no-products').removeClass('--is-visible');
	}
}

function updateCategoriesVisibility() {
	$('.products-by-category').each(function() {
		const categoryBlock = $(this);
		const categoryTitle = categoryBlock.find('.category-title');
		const productsGrid = categoryBlock.find('.products-grid');
		const products = productsGrid.find('.product-card');

		const visibleProductsInCategory = products.not('.--hidden').length;

		if (visibleProductsInCategory === 0) {
			productsGrid.addClass('--hidden');
			categoryTitle.addClass('--hidden');
		} else {
			productsGrid.removeClass('--hidden');
			categoryTitle.removeClass('--hidden');
		}
	});
}

// Animation de la hauteur du conteneur des produits
function animateProductsContainerHeight(callback) {
	const container = document.querySelector('.all-products-ctn');
	const content = document.querySelector('.all-products');

	if (!container || !content) {
		if (typeof callback === 'function') callback();
		return;
	}

	// Nettoie une transition précédente
	container.style.transition = 'none';
	container.style.height = container.offsetHeight + 'px';

	// Force repaint
	container.offsetHeight;

	// Remet la transition
	container.style.transition = 'height 0.4s ease';

	if (typeof callback === 'function') callback();

	const endHeight = content.scrollHeight;

	requestAnimationFrame(function() {
		container.style.height = endHeight + 'px';
	});

	const onTransitionEnd = function(event) {
		if (event.propertyName !== 'height') return;

		container.style.height = 'auto';
		container.removeEventListener('transitionend', onTransitionEnd);
	};

	container.addEventListener('transitionend', onTransitionEnd);

	wait(1200).then(function() {
		container.style.height = 'auto';
	});
}

const debouncedFilterProducts = debounce(function() {
	filterProducts();
}, 300);


/**
 *                                                                                                                            
 *     ###### # #      ##### ###### #####     #####  #   #     ####    ##   ##### ######  ####   ####  #####  # ######  ####  
 *     #      # #        #   #      #    #    #    #  # #     #    #  #  #    #   #      #    # #    # #    # # #      #      
 *     #####  # #        #   #####  #    #    #####    #      #      #    #   #   #####  #      #    # #    # # #####   ####  
 *     #      # #        #   #      #####     #    #   #      #      ######   #   #      #  ### #    # #####  # #           # 
 *     #      # #        #   #      #   #     #    #   #      #    # #    #   #   #      #    # #    # #   #  # #      #    # 
 *     #      # ######   #   ###### #    #    #####    #       ####  #    #   #   ######  ####   ####  #    # # ######  ####  
 *                                                                                                                            
 */
$(document).ready(function() {
	const categoriesFilter = $('.module-categories-filters');
	const firstFilter = categoriesFilter.find('.category-group').get(0);

	if (firstFilter) {
		firstFilter.classList.add('--is-open');
	}

	// Filtres catégories + sous-catégories
	$('.module-categories-filters .checkbox-group input').on('change', function() {
		filterProducts();
	});

	// Recherche
	// On n'enlève plus les filtres cochés.
	// La recherche fonctionne maintenant AVEC les filtres.
	$('#search-input').on('input', function() {
		debouncedFilterProducts();
	});

	/**
 	*                                              
	*     #####  ####   ####   ####  #      ###### 
	*       #   #    # #    # #    # #      #      
	*       #   #    # #      #      #      #####  
	*       #   #    # #  ### #  ### #      #      
	*       #   #    # #    # #    # #      #      
	*       #    ####   ####   ####  ###### ###### 
	*                                              
	*/
	// Categories drawer
	const toggleElements = ['.open-filters', '.close-filters', '.filters-backdrop'];

	toggleElements.forEach(function(selector) {
		const element = document.querySelector(selector);

		if (!element) return;

		element.addEventListener('click', function() {
			categoriesFilter.toggleClass('--is-open');
		});
	});

	// Category accordions
	$('.category-header').on('click', function() {
		const category = $(this).closest('.category-group');
		category.toggleClass('--is-open');
	});
});